export const DEFAULT_CARD_FORMAT = /(\d{1,4})/g;

export const PLACEHOLDER: PaymentCardType = {
  displayName: 'placeholder',
  type: 'generic',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /.*/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
};

export interface PaymentCardType {
  displayName: string;
  type: string;
  aliases?: string[];
  format: RegExp;
  startPattern: RegExp;
  gaps: number[];
  lengths: number[];
}

export const CARD_TYPES: PaymentCardType[] = [
  {
    displayName: 'Visa',
    type: 'visa',
    format: DEFAULT_CARD_FORMAT,
    startPattern: /^4/,
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
  },
  {
    displayName: 'Mastercard',
    type: 'mastercard',
    aliases: ['mccredit', 'mcstandardcredit', 'mc', 'mcpremiumcredit'],
    format: DEFAULT_CARD_FORMAT,
    startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
    gaps: [4, 8, 12],
    lengths: [16],
  },
  {
    displayName: 'American Express',
    type: 'american-express',
    aliases: ['amex'],
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    startPattern: /^3[47]/,
    gaps: [4, 10],
    lengths: [15],
  },
  {
    displayName: 'Diners Club',
    type: 'diners-club',
    aliases: ['diners'],
    format: DEFAULT_CARD_FORMAT,
    startPattern: /^(36|38|30[0-5])/,
    gaps: [4, 10],
    lengths: [14, 16, 19],
  },
  {
    displayName: 'Discover',
    type: 'discover',
    format: DEFAULT_CARD_FORMAT,
    startPattern: /^(6011|65|64[4-9]|622)/,
    gaps: [4, 8, 12],
    lengths: [16, 19],
  },
];

export const getCardTypeByValue = (value: string) =>
  CARD_TYPES.filter((cardType: PaymentCardType) =>
    cardType.startPattern.test(value),
  )[0] ?? PLACEHOLDER;

export const getCardTypeByType = (type: string) =>
  CARD_TYPES.filter(
    (cardType: PaymentCardType) =>
      type.includes(cardType.type) ||
      cardType.type.includes(type) ||
      cardType.aliases?.some((alias) => type.includes(alias)) ||
      cardType.aliases?.some((alias) => alias.includes(type)),
  )[0];
